export const LOCAL_STORAGE = {
    UserGUID: 'UserGUID'
}